module.exports = __webpack_public_path__ + "img/enableExtendConfirmSetting_03.77c2044a.png";